import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-200/70 border-t border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-bold text-foreground-950">
                田中瞳
              </span>
              <span className="text-xs text-foreground-600 tracking-wider uppercase ml-1">
                Official
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              田中瞳官方资讯与作品全览，为您提供最新动态、作品资讯、演艺经历等全方位内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/latest-news" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  最新动态
                </Link>
              </li>
              <li>
                <Link to="/category/works" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  作品集
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-base"></i>
                <span>contact@lampbus.cn</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line text-base"></i>
                <span>东京都港区南青山</span>
              </li>
            </ul>
            <div className="flex gap-3 mt-4">
              <a
                href="https://twitter.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300/50 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a
                href="https://weibo.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300/50 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300/50 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-300/60">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 田中瞳官方资讯站. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}